import { markRaw } from 'vue';
import { ParcelListType, type ModuleConfigPartial, LayerListPosition } from '@maximap-base';
import {
  FertilizerPlanTypeIcon,
  HomogenousDosePlanIcon,
  SeedPlanTypeIcon,
  SelfZoneDosePlanIcon,
  ZoneStrengthDosePlanIcon
} from '@maximap-base';
import { PlanFileType } from '@maximap-base';
import { DosePlan, PlanType } from '@maximap-base';

export const getAppConfig = {
  parcel: {
    needParcelGroups: false,
    needGeoLayerUpload: false,
    listType: ParcelListType.TABLE,
    layerListPosition: LayerListPosition.TOP,
    needParcelLayerEditButton: false,
    needParcelSubLayerButton: false
  },
  map: {
    mapSourceURL: '',
    addedLayersNavLocation: 'left',
    layersNavLocation: 'right',
    numberOfMaps: 2,
    needSettings: false,
    needAutoMapChange: false,
    mapsOrientation: 'vertical'
  },
  fertilizer: {
    needFilters: false,
    needAddNew: false,
    needHeader: false
  },
  plan: {
    needExpertAdvice: false,
    needFileUpload: false,
    needSidenav: false,
    needZoneDetails: false,
    needDetailsLayerChooser: false,
    needDetailsZoom: false,
    planChooserType: 'button',
    planTypeOptions: [
      {
        planType: PlanType.FERTILIZER_PLAN,
        title: 'plan.planType.fertilizerPlan',
        icon: markRaw(FertilizerPlanTypeIcon)
      },
      {
        planType: PlanType.SEED_PLAN,
        title: 'plan.planType.seedPlan',
        icon: markRaw(SeedPlanTypeIcon)
      }
    ],
    doseTypeOptions: [
      {
        doseType: DosePlan.HOMOGENEOUS,
        title: 'plan.dosePlan.homogeneous',
        icon: markRaw(HomogenousDosePlanIcon)
      },
      {
        doseType: DosePlan.ZONE_STRENGTH,
        title: 'plan.dosePlan.zoneStrength',
        icon: markRaw(ZoneStrengthDosePlanIcon)
      },
      {
        doseType: DosePlan.SELF_ZONE,
        title: 'plan.dosePlan.selfZone',
        icon: markRaw(SelfZoneDosePlanIcon)
      }
    ],
    availableDownloadFormats: [PlanFileType.SHP, PlanFileType.TOPCON]
  }
} as ModuleConfigPartial;
